if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.querySelector('input[name="properties[_cart_added_at]"]')?.setAttribute('value', Date.now());
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.toggleAttribute("data-loading", true);
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              // this.handleErrorMessage(response.description);

              // Max quantity reached: show toast and disable all ATC buttons
              if (response.status === 422) {
                this.showMaxQuantityToast();
                this.disableAllAtcButtons();
              } else {
                this.handleErrorMessage(response.description);
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                productHandle: formData.get('product-handle'),
                cartData: response,
              });
            publish(PUB_SUB_EVENTS.closeCliponModal, {
              dialogId: 'clipon-product-modal'
            });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              document.dispatchEvent(new CustomEvent('cart-drawer:open'));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute("data-loading");
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || this.submitButton.classList.contains('add-clipon-button')) return;
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
            console.log('method started disabled');

          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
            console.log('method started enabled')
          }

      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      showMaxQuantityToast() {
        const toast = document.getElementById('op-max-quantity-toast');
        if (!toast) return;

        toast.removeAttribute('hidden');
        requestAnimationFrame(() => {
          toast.classList.remove('tw-opacity-0', '-tw-translate-y-4');
          toast.classList.add('tw-opacity-100', 'tw-translate-y-0');
        });

        const closeBtn = document.getElementById('op-max-quantity-toast-close');
        const dismiss = () => {
          toast.classList.remove('tw-opacity-100', 'tw-translate-y-0');
          toast.classList.add('tw-opacity-0', '-tw-translate-y-4');
          toast.addEventListener('transitionend', () => toast.setAttribute('hidden', ''), { once: true });
          clearTimeout(autoDismissTimer);
        };

        closeBtn?.addEventListener('click', dismiss, { once: true });
        const autoDismissTimer = setTimeout(dismiss, 5000);
      }

      disableAllAtcButtons() {
        document.querySelectorAll('button[data-element-id="Prod_AddCart"], button[data-element-id="Stickybar_AddCart"]').forEach((btn) => {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('aria-disabled', 'true');
        });
      }
    }
  );
}
